import { Injectable } from '@angular/core';

import { InviteRole, InviteStatus } from '@shared/invite/enums';
import { Invite } from '@shared/invite/models';
import { InvitesFilters } from '../../models';

@Injectable()
export class InvitesFilterService {
  filter({ email, role, location, status }: InvitesFilters, invites: Invite[]): Invite[] {
    return invites.filter(invite => this.compareByEmail(email, invite) &&
      this.compareByRole(role, invite) &&
      this.compareByLocation(location, invite) &&
      this.compareByStatus(status, invite));
  }

  private compareByEmail(searchQuery: string, invite: Invite): boolean {
    if (searchQuery === '') {
      return true;
    }

    return invite.email.includes(searchQuery);
  }

  private compareByRole(role: InviteRole | null, invite: Invite): boolean {
    if (role) {
      return invite.role === role;
    }

    return true;
  }

  private compareByLocation(locationId: string | null, invite: Invite): boolean {
    if (locationId && invite.locations) {
      return invite.locations.includes(locationId);
    }

    return true;
  }

  private compareByStatus(status: InviteStatus | null, invite: Invite): boolean {
    if (status) {
      return invite.status === status;
    }

    return true;
  }
}
